import {Injectable} from '@angular/core';
import {Subject, forkJoin} from 'rxjs';
import {HttpParams} from '@angular/common/http';

import {AuthHttpService} from './auth-http.service';

import {Globals} from '../globals';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {CreateDialogComponent} from "../shared/dialogs/create-dialog/create-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class AdminSensorsService {

  private _sensorsData = [];
  private _dataSubject = new Subject<any>();
  public isDataAvailable = false;
  public error_data_lang: string;
  public res_dict_status: any[];

  constructor(private http: AuthHttpService, public dialog: MatDialog, public Globals: Globals) {
  }

  // функция для перевода, принимает строку, преобразовывает в массив, каждый элемент массива переводит и возвращает обратно строку

  public translateStatus = (status_list: string) => {
    const status_arr = status_list.split(', ');

    // console.log('string to status_arr', status_arr);

    // переводим
    const translated_arr = [];
    let translated_status: string;

    status_arr.forEach(word => {
      // меняем на перевод в зависимости от выбранного языка
      const current_lang = this.Globals.lang;
      const found_word = this.res_dict_status.find((word_obj: { code: string; }) => word_obj.code == word);
      if (Boolean(found_word)) {
        const found_name_arr = JSON.parse(found_word.name);
        translated_arr.push(found_name_arr[current_lang]);
      } else {
        const found_name_arr = {
          'en': 'No status. Check reading',
          'es': 'Sin Estado. lectura de cheques',
          'ru': 'Нет статуса. Проверьте считывание'
        };
        translated_arr.push(found_name_arr[current_lang]);
      }
      // console.log('found_name_arr', found_name_arr[current_lang]);
    });
    translated_status = translated_arr.toString();
    // добавляем пробел после запятой
    translated_status = translated_status.split(',').join(', ');
    return translated_status;
  }

  private setData(sensors_data: any) {
    this._sensorsData = sensors_data;
    this._dataSubject.next(sensors_data);
  }

  public sensors(params: any = {}): Subject<any> {

    if (!this._sensorsData.length) {
      this.fetchSensors(params);
    }
    return this._dataSubject;
  }

  public async fetchSensors(params: any = {}) {
    let sensors_params: HttpParams = new HttpParams();
    Object.entries(params).forEach(entry => {
      const [key, value] = entry;
      sensors_params = sensors_params.set(key, value.toString());
    });
    try {
      //получаем датчики, статусы и полосы и объеиняем их в один массив
      const res = await this.http.get('/api/admin-sensors/data', {params: sensors_params}).toPromise();
      let ids: string[] = [];
      //let statusParams: HttpParams = new HttpParams();
      let statusParams = {'sensor_id_list': ''};
      res.body.forEach((sensor: { sensor_id: string; }) => {
        ids.push(sensor.sensor_id);
      });
      statusParams.sensor_id_list = JSON.stringify(ids);

      let fetchData$ = forkJoin({
        statusData: this.http.post('/api/sensor/status_v', statusParams),
        DictStatusData: this.http.get('/api/dict/det_sensor_status_dict'),
      });

      const statusRes = await fetchData$.toPromise();

      let res_status = statusRes.statusData.body;

      // добавили получение из словаря перевода детальных статусов
      this.res_dict_status = statusRes.DictStatusData.body;

      //меняем формат даты под сафари
      //переводим язык статуса
      let sensors_data = res.body.map((sensor) => {
        if (sensor.update_ts != null) {
          sensor.update_ts = sensor.update_ts.replace(' ', 'T');
        }
        return sensor;
      });

      sensors_data.forEach((s: {
        [x: string]: number | string;
        status_v: number;
        status_v_list: string;
        sensor_id: any;
        del_from_project: any;
      }) => {

        // далее проверяем таблицу статусов и в случае соответствия выставляем текущий статус
        s.status_v = 0;
        s.status_v_list = '';

        if (res_status.length > 0) {
          res_status.forEach((sv: { sensor_id: any; current_status_code: number; current_status_list: string; }) => {
            if (sv.sensor_id == s.sensor_id) {
              s.status_v = sv.current_status_code;
              s.status_v_list = this.translateStatus(sv.current_status_list);
            }
          });
        }
        if (s.del_from_project) {
          s['status_v'] = 3;
        }
      });

      /* СОРТИРОВКА по статусу и по имени внутри статуса */
      let sorted_arr = this.sortSensorsNameStatus(JSON.stringify(sensors_data));

      sensors_data = JSON.parse(JSON.stringify(sorted_arr));
      this.setData(sensors_data);

    } catch (err) {

      if (err.status !== 401 && err.status !== 403 && err.status !== 423 && this.Globals.error) {
        this.Globals.error = false;
        this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
          data: {
            act: "error",
            text: this.error_data_lang,
            icon_class: "dialog-icon-warning"
          }
        });
        this.isDataAvailable = true;
      }
    }
  }

  public getSensorsGlobalData() {
    return this._sensorsData;
  }

  public clearSensorsGlobalData() {
    this.setData([]);
  }

  private sortSensorsNameStatus(sensors_array: string) {
    //требуется отсортировать по статусу и по имени внутри статусов
    // для этого создадим массивы по статусам, отсортируем в них по имени, а затем объединим

    let status_green_arr = [];
    let status_red_arr = [];
    let status_yellow_arr = [];
    let status_grey_arr = [];
    let status_blue_arr = [];

    JSON.parse(sensors_array).forEach((sensor: { status_v: any; }) => {
      switch (sensor.status_v) {
        case 0:
          status_red_arr.push(sensor);
          break;
        case 1:
          status_green_arr.push(sensor);
          break;
        case 2:
          status_yellow_arr.push(sensor);
          break;
        case 3:
          status_grey_arr.push(sensor);
          break;
        case 4:
          status_blue_arr.push(sensor);
          break;
      }
    });

    //сортируем массивы по имени если в массивах больше 1 элемента
    if (status_red_arr.length > 1) {
      status_red_arr.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (status_green_arr.length > 1) {
      status_green_arr.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (status_yellow_arr.length > 1) {
      status_yellow_arr.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (status_grey_arr.length > 1) {
      status_grey_arr.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (status_blue_arr.length > 1) {
      status_blue_arr.sort((a, b) => a.name.localeCompare(b.name));
    }

    //объединяем в один и меняем предыдущий массив датчиков
    let sorted_arr = [];
    sorted_arr = [...status_green_arr, ...status_yellow_arr, ...status_red_arr, ...status_blue_arr, ...status_grey_arr];
    sensors_array = JSON.parse(JSON.stringify(sorted_arr));
    return sensors_array;
  }

}
